export const genIdempotencyKey = (meaningfulDescriptor) => {
    return `${new Date().toISOString()}-${meaningfulDescriptor}`;
};
//# sourceMappingURL=genIdempotencyKey.js.map